module.exports = __webpack_public_path__ + "img/制川乌.b5bddfa4.jpg";